<script lang="ts">
  import { Button, Loader } from '$shared/components';
  import Module from '$provider/lib/apis/models/permission/Module';
  import authService from '$shared/services/authService';
  import { ButtonStyle } from '$shared/constants/ButtonStyle';

  interface Props {
    loading?: boolean;
    disabled?: boolean;
    onreject?: () => void;
    onaccept?: () => void;
  }

  let { loading = false, disabled = false, onreject, onaccept }: Props = $props();
</script>

<div class="actions">
  {#if loading}
    <div class="loader">
      <Loader />
    </div>
  {:else}
    <div class="action">
      <Button
        name="rejectRecord"
        disabled={disabled || !authService.getUserRole().hasWritePermission(Module.Providers)}
        icon="icon-x"
        onclick={onreject}>Reject record</Button
      >
    </div>
    <div class="action">
      <Button
        name="acceptRecord"
        disabled={disabled || !authService.getUserRole().hasWritePermission(Module.Providers)}
        icon="icon-check"
        style={ButtonStyle.Primary}
        onclick={onaccept}>Accept record</Button
      >
    </div>
  {/if}
</div>

<style>
  .actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .actions .action:not(:last-child) {
    margin-right: 16px;
  }
  .actions .loader {
    width: 100px;
  }
</style>
